// extracted by mini-css-extract-plugin
module.exports = {"overlay":"MiniModal_overlay__12S5C","remove":"MiniModal_remove__2ioE1"};